import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { LoadScenarioModal } from './load-scenario/load-scenario.component';
import { first } from 'rxjs/operators';
import { ISaveScenario, SaveScenarioModal } from './save-scenario/save-scenario.component';

@Injectable()
export class ModalService {
  constructor(private dialog: MatDialog) {}

  // Método para cargar los elementos desde localStorage
  public loadScenario(items: Array<any>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let dialogRef: MatDialogRef<LoadScenarioModal>;
      const config = new MatDialogConfig();
      config.disableClose = false;

      // Abrimos el modal de carga de elementos
      dialogRef = this.dialog.open(LoadScenarioModal, config);

      // Pasamos los elementos cargados desde localStorage al modal
      dialogRef.componentInstance.items = items;
      
      // Cuando se cierra el modal, devolvemos el item seleccionado
      dialogRef.afterClosed().pipe(first()).subscribe((data: any) => {
        resolve(data);  // Devolvemos el item seleccionado
      });
    });
  }

  // Método para guardar los elementos desde localStorage en el modal
  public saveScenario(items: Array<any>): Promise<ISaveScenario> {
    return new Promise((resolve, reject) => {
      let dialogRef: MatDialogRef<SaveScenarioModal>;
      const config = new MatDialogConfig();
      config.disableClose = false;

      // Abrimos el modal de guardar
      dialogRef = this.dialog.open(SaveScenarioModal, config);

      // Pasamos los elementos filtrados al modal de guardar
      dialogRef.componentInstance.items = items.filter(item => item.editable);
      
      // Cuando se cierra el modal, resolvemos el objeto ISaveScenario
      dialogRef.afterClosed().pipe(first()).subscribe((data: ISaveScenario) => {
        resolve(data);
      });
    });
  }
}
